"use client";

import React, { useEffect, useState } from "react";
import AppIcon from "@/src/shared/Icon";
import OverlayScrollbar from "@/src/shared/OverlayScrollbar";
import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";

import Slider, { Settings } from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NavButton from "@/src/shared/slick/SlickNavButton";
import SlickNavButton from "@/src/shared/slick/SlickNavButton";

export default function FeatureSection(props:any) {

    const [selectedFeature, setSelectedFeature] = useState<any>(null);

    const features = [
        {
            icon: "watch_video_mobile",
            image: "earning.gif",
            title: "Turn watch time into Earning.",
            desc: "Get rewarded just for watching short video ads. Every second you spend earns you real money—no tricks, just instant value for your watch time.",
        },
        // {
        //     icon: "survey",
        //     title: "Respond to survey and Get Paid.",
        //     desc: "Your thoughts matter! Answer simple questions in surveys and earn instantly. It’s one of the easiest ways to grow your wallet with zero experience.",
        // },
        {
            icon: "smartphone_wifi",
            image: "data.png",
            title: "Buy cheap Data Plans.",
            desc: "Stay connected for less. Enjoy discounted mobile data bundles for MTN, Airtel, Glo, and 9mobile—fast delivery, full control, and no extra charges.",
        },
        {
            icon: "phone_credit_card",
            image: "airtime.png",
            title: "Instant Recharge Airtime.",
            desc: "Skip the scratch cards. Recharge your phone with airtime in a few taps—at lower rates than your mobile provider.",
        },
        {
            icon: "bill",
            image: "bill-payment.png",
            title: "Pay Utility Bills.",
            desc: "Electricity, cable TV, internet—pay them all with ease using your Enanpay wallet. No queues. No late fees. Just fast, reliable payments.",
        },
    ];

    const settings: Settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        vertical: true,
        verticalSwiping: true,
        nextArrow: <SlickNavButton navDirection="up" />,
        prevArrow: <SlickNavButton navDirection="down" />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                    nextArrow: <SlickNavButton navDirection="next" />,
                    prevArrow: <SlickNavButton navDirection="prev" />,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                    nextArrow: <SlickNavButton navDirection="next" />,
                    prevArrow: <SlickNavButton navDirection="prev" />,
                }
            },
        ],
        
    };

    useEffect(() => {
        setSelectedFeature(features[0]);
    }, []);

    return (
        <div className="section bg-gray-900">
            <div className="w-full lg:max-w-4xl">
                <h1 className="text-3xl lg:text-5xl/snug text-gray-100 tracking-wider"><strong>Do More</strong> with Your Phone – <strong>Earn</strong> and <strong>Pay</strong> Smarter with Enanpay</h1>
                <p className="text-lg text-gray-400 dark:text-gray-300 mt-7">
                    Other apps just help you spend — Enanpay helps you earn. If they’re afraid to build it, we already did. From online tasks to cheap data and instant bill payments, Enanpay is the all-in-one money app built for Nigerians who want more.
                </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="hidden lg:flex justify-center">
                    <AnimatePresence mode="wait">
                        <motion.img
                            key={selectedFeature? selectedFeature.title : "feature-img" }
                            // src={"/images/screens/home.png"} 
                            src={`/images/features/${selectedFeature?.image}`}
                            alt="home"
                            className="h-200 w-auto"
                            width={"auto"}
                            height={"auto"}
                            initial={{ y: 10, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: -10, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                        />
                    </AnimatePresence>
                </div>
                <div>
                    <div 
                        className="max-sm:slider-container lg:max-h-200 flex flex-col"
                    >
                        <Slider {...settings}>
                            {features.map((item:any) => {
                                return (
                                    <motion.div
                                        key={item.title}
                                        data-selected={selectedFeature?.title == item.title}
                                        className="flex flex-col gap-y-2 hover:bg-gray-800 data-[selected=true]:bg-gray-800 transition-colors duration-700 p-7 rounded-xl 
                                                    cursor-pointer"
                                        onClick={() => setSelectedFeature(item)}
                                    >
                                        <div className="flex justify-center lg:hidden">
                                            <img 
                                                src={`/images/features/${item.image}`} 
                                                alt={item.title}
                                                className="h-auto w-60"
                                                width={"auto"}
                                                height={"auto"}
                                            />
                                        </div>
                                        <div className="flex flex-col gap-y-2 mt-4">
                                            <AppIcon icon={item.icon} className="text-gray-300 text-[3rem]" />
                                            <h2 className="text-lg text-gray-100 font-medium tracking-wider">
                                                { item.title }
                                            </h2>
                                            <p className="text-gray-400">
                                                { item.desc }
                                            </p>
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
}